<template>
  <div class="all">
    <div class="core-info">
      <CurrentTarget />
      <DashboardMessage />
      <router-link to="/BETTER">BETTER.</router-link>
      <router-link to="/FIGUREITOUT">FIGURE IT OUT.</router-link>
    </div>
    <SideControls />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CurrentTarget from "../../components/CurrentTarget";
import SideControls from "../../components/SideControls";
import DashboardMessage from "../../components/DashboardMessage";

export default {
  name: "Home",
  computed: {
    ...mapState({
      authenticated: (state) => state.auth.authenticationStatus,
      ready: (state) => state.auth.ready,
    }),
  },
  components: {
    CurrentTarget,
    SideControls,
    DashboardMessage,
  },
  data() {
    return {
      loaded: false,
    };
  },
  created() {
    if (this.ready) {
      this.loaded = true;
    }
  },
};

/**
 * @todo
 * [] Make current target a link that takes to elaborated description of what the current target is and why
 */
</script>

<style scoped>
.all {
  display: flex;
  position: relative;
  height: calc(100vh - 36px);
}

.core-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>